import React from 'react'
import Grid from '@material-ui/core/Grid/Grid'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'


import Tarif from '../../Component/Hotel/Tarif'
import Origine from '../../Component/Hotel/Origine'
import Segmentation from '../../Component/Hotel/Segmentation'
import FicheStock from '../../Component/Hotel/FicheStock'
import Planning from '../../Component/Hotel/Planning'
import GrilleTarifaire from '../../Component/Hotel/GrilleTarifaire'



export default (class extends React.Component {

    state = {
        UserTabSelected: 0,
        busGUID: Utils.uuidv4()
    }

    crmConfiguration = [
        { nom: 'Fiche de Stock', component: <FicheStock /> },
        { nom: 'Tarif', component: <Tarif /> },
        { nom: 'Origine', component: <Origine /> },
        { nom: 'Segmentation', component: <Segmentation /> },
        { nom: 'Planning', component: <Planning /> },
        { nom: 'GrilleTarifaire', component: <GrilleTarifaire /> }
    ]




    componentWillUnmount() {
        Bus.$off('donnees_annexes_hotel', this.state.busGUID)
    }

    componentDidMount() {
        Bus.$on('donnees_annexes_hotel', id => {
            this.setState({ UserTabSelected: id })
        }, this.state.busGUID)
    }

    render() {
        return <Grid container style={{ margin: 0, padding: 0, width: '100%', height: '100%' }} spacing={0}>
            <Grid item xs={12} key={this.state.UserTabSelected} style={{ margin: 0, padding: 0, width: '100%', height: '100%' }}>
                {
                    this.crmConfiguration[this.state.UserTabSelected].component
                }
            </Grid>
        </Grid>
    }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/Hotel/index.js